import React from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

const Badge = ({ children, color = 'GRAY' }) => {
  const badgeColor = Colors[color] || Colors.GRAY;

  const styles = {
    component: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px 10px',
      borderRadius: BorderRadius.DEFAULT,
      backgroundColor: `${badgeColor.hex}20`,
      color: badgeColor.hex,
      fontSize: FontSizes.SMALL,
      fontWeight: FontWeights.MEDIUM,
      lineHeight: 1,
      border: `1px solid ${badgeColor.hex}40`,
      whiteSpace: 'nowrap'
    }
  };

  return <span style={styles.component}>{children}</span>;
};

Badge.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(Object.keys(Colors))
};

export default Badge;
